<template>
  <Dialog ref="Dialog" :key="$attrs.visible" v-el-drag-dialog :class="fullScreen ? 'fullScreenView' : ''" v-bind="$attrs"
    :fullscreen="getFullscreen" v-on="$listeners">
    <template v-if="!Object.keys($slots).includes('title')">
      <div slot="title" class="title">
        <span>{{ $attrs.title }}</span>
        <i v-if="$attrs.fullscreen === undefined" class="el-icon-full-screen fullScreenIcon"
          @click="fullScreen = !fullScreen" />
      </div>
    </template>
    <template v-for="key in Object.keys($slots)" #[key]>
      <slot :name="key" />
    </template>
  </Dialog>
</template>

<script>
import { Dialog } from 'element-ui'
import elDragDialog from '@/directive/el-drag-dialog' // base on element-ui
export default {
  directives: { elDragDialog },
  components: { Dialog },
  data() {
    return {
      fullScreen: false,
      top: 0,
      left: 0
    }
  },
  computed: {
    getFullscreen() {
      if (this.$attrs.fullscreen !== undefined) {
        return this.$attrs.fullscreen
      } else {
        return this.fullScreen
      }
    }
  },
  watch: {
    getFullscreen: {
      handler(newVal) {
        if (!this.$refs.Dialog) return
        const elDialog = this.$refs.Dialog.$el.querySelector('.el-dialog')
        if (newVal === true) {
          this.top = elDialog.style.top
          this.left = elDialog.style.left
          elDialog.style.top = '0px'
          elDialog.style.left = '0px'
        } else {
          elDialog.style.top = this.top
          elDialog.style.left = this.left
        }
        this.setMaxHeight()
        this.setBodyHeight()
      }
    },
    '$attrs.visible'(newVal) {
      console.log('设置高度')
      if (newVal) {

        this.$nextTick(() => {
          this.setMaxHeight()
          this.setBodyHeight()
        })
      }
    }
  },
  methods: {
    // 设置展示区域
    setBodyHeight() {
      this.$nextTick(() => {
        const elDialog = this.$refs.Dialog.$el.querySelector('.el-dialog')
        const elDialogHeader = elDialog.querySelector('.el-dialog__header')
        const elDialogBody = elDialog.querySelector('.el-dialog__body')
        const elDialogFooter = elDialog.querySelector('.el-dialog__footer')
        Object.assign(elDialogBody.style, {
          height: `calc(100% - ${Math.ceil(elDialogHeader?.offsetHeight || 0)}px - ${Math.ceil(elDialogFooter?.offsetHeight || 0)}px)`,
          overflow: 'auto'
        })
      })
    },
    // 设置最大高度
    setMaxHeight() {
      // 如果弹窗的高度超过窗口的高度，进行样式调整
      this.$nextTick(() => {
        const windowHeight = window.innerHeight
        const elDialog = this.$refs.Dialog.$el.querySelector('.el-dialog')
        const elDialogWrapper = this.$refs.Dialog.$el
        if (elDialog.offsetHeight > windowHeight || elDialogWrapper.scrollHeight > windowHeight) {
          console.log('进来了')
          Object.assign(elDialog.style, {
            margin: '0 auto', // 弹窗居中
            height: '100vh'
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.fullScreenIcon {
  margin-right: 30px;
  cursor: pointer;
}

.fullScreenIcon:hover {
  color: var(--active-color);
}

.fullScreenView {
  ::v-deep .el-dialog__body {
    display: flex;
    flex-flow: column;
    height: calc(100% - 46px);
  }

  ::v-deep .el-dialog__body .content {
    display: flex;
    flex-flow: column;
    height: 100%;
  }

  ::v-deep .el-dialog__body .content .el-table {
    flex: 1;
  }
}
</style>

